import * as React from "react"

function PagamentiSicuri(props) {
    return (
        <svg
            id="prefix__Livello_1"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 50 50"
            xmlSpace="preserve"
            {...props}
        >
            <path
                className="prefix__st0"
                d="M37.8 21.3c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3-1.8 0-3.3-1.5-3.3-3.3.1-1.8 1.5-3.3 3.3-3.3z"
            />
            <path
                className="prefix__st0"
                d="M5.6 3.1h38.7c2.3 0 4.2 1.9 4.2 4.2v34.5c0 2.3-1.9 4.2-4.2 4.2H5.6c-2.3 0-4.2-1.9-4.2-4.2V7.3c0-2.3 1.9-4.2 4.2-4.2zM32.2 16.8h16.3M48.5 32.4H32.2M32.2 32.4c-1.3 0-2.4-1.1-2.4-2.4M29.7 29.9V19.2M29.7 19.2c0-1.3 1.1-2.4 2.4-2.4"
            />
        </svg>
    )
}

export default PagamentiSicuri
